import { Injectable, signal } from '@angular/core';
import { Version } from '../types';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class Versioning {
  private readonly _upToDate = signal<boolean>(!this.shouldDisplayReleaseNotes);
  public readonly upToDate = this._upToDate.asReadonly();

  constructor() {
    if (this.shouldDisplayReleaseNotes || !this.currentVersion) {
      this._upToDate.set(false);
    }
  }

  public get currentVersion(): Version {
    return localStorage.getItem('version') as Version;
  }

  public set currentVersion(version: Version) {
    localStorage.setItem('version', version);
  }

  public get shouldDisplayReleaseNotes(): boolean {
    return environment.currentVersion !== this.currentVersion || !this.currentVersion;
  }

  public update(): void {
    this.currentVersion = environment.currentVersion as Version;
    this._upToDate.set(true);
  }
}
